<div
  class="outer-container flex h-full flex-col transition-transform duration-200 ease-in-out"
>
  @if (isRecommended) {
    <app-small-badge
      *transloco="let t"
      [icon]="'star'"
      [text]="t('portal.courseLibrary.perfectForTheStart')"
    >
    </app-small-badge>
  }

  <div
    class="inner-container flex h-full w-[332px] cursor-pointer flex-col rounded-xl border-2 border-grey-lightGrey p-4 shadow-sm transition-all duration-200 ease-in-out"
    *transloco="let t"
    [class.shadow]="isRecommended"
    [class.locked]="course.isLocked"
    [class.bg-grey-veryLightGrey]="course.isLocked"
    [class.text-grey]="course.isLocked"
    tabindex="0"
    (keydown.enter)="courseCardClickEvent.emit()"
    (click)="courseCardClickEvent.emit()"
  >
    @if (course.isLocked) {
      <div
        class="lock-badge pointer-events-auto absolute right-3 top-3 z-[5] flex cursor-pointer items-center gap-1.5 rounded-2xl border border-gray-200 bg-grey-midGrey px-3 py-1.5 text-xs font-semibold text-grey"
        [matTooltip]="
          t('portal.courseLibrary.lockedTooltip', {
            topicArea: t('portal.topicAreas.' + course.topicAreaName),
          })
        "
        matTooltipPosition="above"
      >
        <mat-icon class="lock-badge-icon text-primary">lock</mat-icon>
        <span>{{ t('portal.courseLibrary.locked') }}</span>
      </div>
    }

    <div class="mb-4 flex items-center">
      <mat-icon
        class="material-icons-outlined"
        style="font-size: 56px; width: 56px; height: 56px"
        [svgIcon]="getCourseIcon()"
      ></mat-icon>
    </div>

    <h2 class="course-title mb-3 line-clamp-2 text-xl font-semibold">
      {{ t('portal.courses.courseTitleKeys.' + course.name + '.name') }}
    </h2>

    <div class="mb-4 text-sm text-grey">
      {{ t('portal.topicAreas.' + course.topicAreaName) }} •
      {{ t('portal.courses.courseTitleKeys.' + course.name + '.duration') }}
    </div>

    <div class="flex-1"></div>

    <p class="course-description line-clamp-3 text-sm text-grey">
      {{ t('portal.courses.courseTitleKeys.' + course.name + '.description') }}
    </p>
  </div>
</div>
